import { CalendarDays, Clock, MapPin, Users, ArrowUpRight, Navigation } from "lucide-react";
import { FadeUp } from "./Reveal";

export const mapsUrl = (lieu) =>
  lieu && !lieu.trim().startsWith("[") ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(lieu.trim())}` : null;

export const wazeUrl = (lieu) =>
  lieu && !lieu.trim().startsWith("[") ? `https://waze.com/ul?q=${encodeURIComponent(lieu.trim())}&navigate=yes` : null;

export const MatchDetails = ({ match }) => {
  const cells = [
    { k: "date", label: "Date", value: match.date, Icon: CalendarDays, cls: "lg:col-span-2" },
    { k: "heure", label: "Coup d'envoi", value: match.heure, Icon: Clock, cls: "" },
    { k: "rdv", label: "Rendez-vous", value: match.rendez_vous, Icon: Users, cls: "bg-lime text-ink" },
    { k: "lieu", label: "Adresse", value: match.adresse || match.lieu, Icon: MapPin, cls: "lg:col-span-4" },
  ];
  return (
    <section id="match" data-testid="match-details-section" className="mx-auto max-w-7xl px-5 py-24 sm:px-10 sm:py-32">
      <FadeUp className="mb-12 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
        <h2 className="font-display text-5xl uppercase leading-none text-chalk sm:text-7xl">La fiche<br />du match</h2>
        <p className="max-w-sm text-base text-dim md:text-lg">Toutes les infos pour être à l'heure. Le rendez-vous, c'est avant le coup d'envoi — pas après.</p>
      </FadeUp>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {cells.map(({ k, label, value, Icon, cls }, i) => (
          <FadeUp key={k} delay={i * 0.08} className={`${cls.includes("col-span-4") ? "sm:col-span-2 " : ""}${cls.replace("bg-lime text-ink", "")}`}>
            <div
              data-testid={`match-detail-${k}`}
              className={`group flex h-full min-h-[180px] flex-col justify-between rounded-[24px] border border-line p-6 transition-colors duration-500 hover:border-lime/60 ${cls.includes("bg-lime") ? "bg-lime text-ink" : "bg-pitch text-chalk"}`}
            >
              <div className="flex items-center justify-between font-mono text-xs uppercase tracking-[0.2em] opacity-80">
                {label}
                <Icon className="h-5 w-5 transition-transform duration-500 group-hover:rotate-12" />
              </div>
              <p className="mt-8 font-display text-3xl uppercase leading-tight sm:text-4xl">{value}</p>
              {k === "lieu" && mapsUrl(value) && (
                <div className="mt-5 flex flex-wrap gap-3">
                  <a href={mapsUrl(value)} target="_blank" rel="noopener noreferrer" data-testid="match-lieu-maps-link" className="inline-flex w-fit items-center gap-2 rounded-full bg-lime px-5 py-3 font-semibold text-ink transition-transform duration-300 hover:-translate-y-0.5">
                    <MapPin className="h-4 w-4" /> Google Maps <ArrowUpRight className="h-4 w-4" />
                  </a>
                  <a href={wazeUrl(value)} target="_blank" rel="noopener noreferrer" data-testid="match-lieu-waze-link" className="inline-flex w-fit items-center gap-2 rounded-full border border-lime px-5 py-3 font-semibold text-lime transition-transform duration-300 hover:-translate-y-0.5">
                    <Navigation className="h-4 w-4" /> Waze <ArrowUpRight className="h-4 w-4" />
                  </a>
                </div>
              )}
            </div>
          </FadeUp>
        ))}
      </div>
    </section>
  );
};
